import { Component, ChangeDetectionStrategy } from '@angular/core';
import { VaBasePricingComponent } from './base-pricing.component';

@Component({
  selector: 'store-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaPricingComponent extends VaBasePricingComponent {}
